import { render, staticRenderFns } from "./package-dialog.vue?vue&type=template&id=bb1bc4ee&"
import script from "./package-dialog.vue?vue&type=script&lang=js&"
export * from "./package-dialog.vue?vue&type=script&lang=js&"
import style0 from "./package-dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports